<template>
  <div class="take-out-edit-container">
    <div class="radio-group">
      <label
        class="radio-option"
        @click="takeOutMode = 'takeOut'"
      >
        <input
          v-model="takeOutMode"
          class="radio-input"
          type="radio"
          value="takeOut"
        />
        <div class="picker" :class="{ selected: takeOutMode === 'takeOut' }"></div>
        <span>現場外帶</span>
      </label>
      <label
        class="radio-option"
        @click="takeOutMode = 'dineInTakeOut'"
      >
        <input
          v-model="takeOutMode"
          class="radio-input"
          type="radio"
          value="dineInTakeOut"
        />
        <div class="picker" :class="{ selected: takeOutMode === 'dineInTakeOut' }"></div>
        <span>內用外帶</span>
      </label>
    </div>

    <div
      v-if="takeOutMode === 'dineInTakeOut'"
      class="table-select"
      :class="takeOutTableName ? 'row_center_center' : 'row_center_between'"
      @click="showTableOption = true"
    >
      <text
        class="text-center font-normal"
        :class="takeOutTableName ? 'text-black' : 'text-[rgba(0,0,0,0.3)]'"
      >
        {{ takeOutTableName || '請選擇桌號 *' }}
      </text>
      <text
        v-if="!takeOutTableName"
        class="button-icon"
        style="color: #FBCB02; font-size: 28px; width: 28px; height: 28px;"
      >
        expand_more
      </text>
    </div>

    <div
      v-if="showTableOption"
      class="row_center_center fixed inset-0 table-popup-mask"
    >
      <div class="column_center_start popup-body">
        <div class="w-full row_center_center">
          <text class="text-xl font-semibold my-6">請選擇桌號</text>
        </div>
        <div class="scroll_flex_container table-options">
          <div
            v-for="(item, index) in dineInTables"
            :key="index"
            class="column_start_start table-option mb-2.5"
            @click="item.tables.length ? null : setTable(item)"
          >
            <text v-if="item.name" class="text-base font-regular mb-2">{{ item.name }}</text>
            <div v-if="item.tables.length" class="grid w-full grid-cols-2 gap-1.5">
              <div
                v-for="(table, tableIndex) in item.tables"
                :key="tableIndex"
                class="row_center_center border border-[#AAAAAA] w-full shrink-0 h-11 rounded-md"
                @click="setTableNumber(item, table)"
              >
                <button class="font-normal">{{ table.name }}</button>
              </div>
            </div>
          </div>
        </div>
        <button class="cancel-button" @click="showTableOption = false">取消</button>
      </div>
    </div>
  </div>
</template>

<script>
import commonUtilities from "@/utils/common.utils";

export default {
  name: 'TakeOutEdit',
  data() {
    return {
      takeOutMode: 'takeOut',
      showTableOption: false
    }
  },
  computed: {
    dineInTables() {
      return this.$store.getters['spreadsheet/dineInTables']
    },
    takeOutTableName() {
      return this.$store.getters['cart/takeOutTableName']
    },
    takeOutTableAreaId() {
      return this.$store.getters['cart/takeOutTableAreaId']
    }
  },
  watch: {
    takeOutMode(mode) {
      if (mode === 'takeOut') {
        this.$store.commit('cart/setTakeOutTableData', {})
      }
    }
  },
  mounted() {
    if (this.takeOutTableAreaId) {
      this.takeOutMode = 'dineInTakeOut'
    }
  },
  methods: {
    setTableNumber(item, table) {
      const tableName = `${item.name}${table.name}`
      const data = {
        tableName,
        areaId: item.areaId,
        tableIndex: item.tables.findIndex(el => el.name === table.name)
      }

      this.$store.commit('cart/setTakeOutTableData', data)
      this.showTableOption = false
    },
    setTable(item) {
      const data = {
        tableName: item.name,
        areaId: item.areaId,
        tableIndex: -1
      }

      this.$store.commit('cart/setTakeOutTableData', data)
      this.showTableOption = false
    },
    validateAllFields() {
      if (this.takeOutMode !== 'dineInTakeOut') return true

      if (!this.dineInTables.length) {
        commonUtilities.createToast('warning', '目前無可選擇桌號')
        return false
      }

      if (!this.takeOutTableAreaId || !this.takeOutTableName) {
        commonUtilities.createToast('warning', '請選擇桌號')
        return false
      }

      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.take-out-edit-container {
  width: 100%;
}

.radio-group {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 28px;
}

.radio-option {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 500;
  color: #000;
  cursor: pointer;
  user-select: none;
}

.radio-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.picker {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #AAAAAA;
  flex-shrink: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.picker.selected {
  border-color: #FACB00;
  border-width: 2px;
}

.picker.selected::before {
  content: '';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #FACB00;
}

.table-select {
  width: 100%;
  height: 54px;
  padding: 0 4%;
  border: #AAAAAA 1px solid;
  border-radius: 6px;
  color: #000;
  font-size: 22px;
  font-weight: 500;
  font-family: PingFang SC;
  margin-top: 18px;
  background-color: #fff;
}

.table-popup-mask {
  z-index: 3000;
  background-color: rgba(0, 0, 0, 0.9);
}

.popup-body {
  width: 80%;
  height: 90%;
  background-color: #fff;
  border-radius: 6px;
  padding-top: 10px;
}

.table-options {
  flex-grow: 1;
  width: 100%;
  background-color: #fff;
}

.table-option {
  width: 80%;
}

.cancel-button {
  width: 100%;
  height: 56px;
  border: none;
  font-size: 20px;
  font-weight: 500;
  font-family: PingFang SC;
  color: #000;
  border-radius: 8px;
  background-color: #EEEEEE;
  flex-shrink: 0;
}
</style>
